<template>
    <ToastItem />
</template>

<script>
export default {
    name: "AlarmComponent",
    computed: {
        /**
         * инициализация получения сообщение из хранилища
         * @returns {*}
         */
        getMessageView() {
            return this.$store.getters["general/getMessageView"];
        },
    },
    watch: {
        /**
         * функция отслеживате новые сообщения, добавляет их в объект toast (всплывающие окно из UI библиотеки primevue)
         * @param newMessage - объект сообщения
         */
        getMessageView(newMessage) {
            this.$toast.add({
                severity: newMessage.type,
                summary: newMessage.summary,
                detail: newMessage.message,
                life: 4000,
            });
        },
    },
};
</script>

<style scoped></style>
